export const validateRole = (groups, roles) => {
    if(roles.length === 0){
        return true;
    }
    let isFounded = groups?.some(group => roles.includes(group));
    return isFounded;
}